<template>
  <div>
    <div class="text-center pt-10 pb-5 Kanit">
      <div>
        <span style="position: relative">
          <v-icon color="primary" size="140">mdi-circle-outline</v-icon>
          <v-icon
            style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "
            color="#F41608"
            size="90"
            >mdi-check</v-icon
          >
        </span>
      </div>
      <div class="primary--text" style="font-size: 18px">สะสมคะแนนสำเร็จ</div>
      <div class="px-7 pt-5">
        <v-btn
          v-if="edittype !== 'edit'"
          style="font-size: 22px"
          class="text-capitalize"
          color="primary"
          dark
          block
          @click="next"
          >อัพบิลเพิ่ม</v-btn
        >
        <v-btn
          @click="$liff.closeWindow()"
          style="font-size: 22px"
          class="text-capitalize mt-2"
          color="grey"
          dark
          block
          >ปิด</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["edittype"],
  methods: {
    next() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>